// extracted by mini-css-extract-plugin
module.exports = {"stats-player-modal":"stats-player-modal","icon":"icon"};